import {
    Android,
    Apartment,
    Assessment,
    Assignment,
    Code,
    FormatAlignCenter,
    Gavel,
    Info,
    MenuBook,
    School,
    Wallpaper
} from "@material-ui/icons"
import { academicPeriodResource } from "../../resources/academic-period"
import { activityTypeResource } from "../../resources/activity-types"
import { classResource } from "../../resources/classes"
import { clientResource } from "../../resources/clients"
import { externalServiceRequestResource } from "../../resources/external-service-requests"
import { formsResource } from "../../resources/forms"
import { formsAvailabilityResource } from "../../resources/forms-availability"
import { formsRequestResource } from "../../resources/forms-requests"
import { guidelineTypeResource } from "../../resources/guideline-types"
import { institutionBranchResource } from "../../resources/institution-branches"
import { institutionResource } from "../../resources/institutions"
import { partyResource } from "../../resources/parties"
import { partyTypeResource } from "../../resources/party-types"
import { processTypeResource } from "../../resources/process-types"
import { processResource } from "../../resources/processes"
import { profileResource } from "../../resources/profiles"
import { questionResource } from "../../resources/question"
import { questionSourceResource } from "../../resources/question-source"
import { questionSourceTypeResource } from "../../resources/question-source-type"
import { quizAssessmentQuestionAvailability } from "../../resources/quiz-assessment-availability"
import { quizAssessmentQuestionResource } from "../../resources/quiz-assessment-question"
import { quizAssessmentQuestionBankResource } from "../../resources/quiz-assessment-question-bank"
import { schedulingResource } from "../../resources/scheduling"
import { schoolActivitiesResource } from "../../resources/school-activities"
import { schoolModelActivitiesResource } from "../../resources/school-model-activities"
import { serviceRequestResource } from "../../resources/service-requests"
import { themeResource } from "../../resources/themes"
import { userContextResource } from "../../resources/user-contexts"
import { userResource } from "../../resources/users"
import { ProfileEnum } from "../../utils/general-profile.enum"
import { resourceProvider } from "../resource-provider/resource-provider"

const JuristtaMenuItem = ({ id, label, icon, path, product, custom, children, profiles, superAdmin }) => {
    return { id, label, icon, path, product, custom, children, profiles, superAdmin }
}

const menus = [
    JuristtaMenuItem({
        id: 'menuSuperAdmin',
        label: 'Superadministrador',
        icon: Assignment,

        children: [

            JuristtaMenuItem({
                id: partyTypeResource.name,
                label: partyTypeResource.options.label,
                icon: partyTypeResource.icon,
                path: partyTypeResource.link,
                product: partyTypeResource.products,
                superAdmin: true,
            }),

            JuristtaMenuItem({
                id: themeResource.name,
                label: themeResource.options.label,
                icon: themeResource.icon,
                path: themeResource.link,
                product: themeResource.products,
                superAdmin: true,
            }),

            JuristtaMenuItem({
                id: profileResource.name,
                label: profileResource.options.label,
                icon: profileResource.icon,
                path: profileResource.link,
                product: profileResource.products,
                superAdmin: true,
            }),

            JuristtaMenuItem({
                id: institutionResource.name,
                label: institutionResource.options.label,
                icon: institutionResource.icon,
                path: institutionResource.link,
                product: institutionResource.products

            }),

            JuristtaMenuItem({
                id: questionSourceTypeResource.name,
                label: questionSourceTypeResource.options.label,
                icon: questionSourceTypeResource.icon,
                path: questionSourceTypeResource.link,
                product: questionSourceTypeResource.products,
                superAdmin: true,
            }),

            JuristtaMenuItem({
                id: questionSourceResource.name,
                label: questionSourceResource.options.label,
                icon: questionSourceResource.icon,
                path: questionSourceResource.link,
                product: questionSourceResource.products,
                superAdmin: true,
            }),

            JuristtaMenuItem({
                id: questionResource.name,
                label: questionResource.options.label,
                icon: questionResource.icon,
                path: questionResource.link,
                product: questionResource.products,
                superAdmin: true,
            }),

            JuristtaMenuItem({
                id: userResource.name,
                label: userResource.options.label,
                icon: userResource.icon,
                path: userResource.link,
                product: userResource.products
            }),

            JuristtaMenuItem({
                id: 'import-question-bank-assessment',
                label: "Importar Banco de Questões (Avaliação)",
                icon: Android,
                path: '/import-assessment-question',
                product: ['school', 'quiz',],
                custom: true,
                superAdmin: true,
                profiles: [ProfileEnum.SUPERADMIN]
            })
        ]
    }),

    JuristtaMenuItem({
        id: 'menuInstitutions',
        label: 'Institucional',
        icon: Apartment,
        children: [

            JuristtaMenuItem({
                id: userContextResource.name,
                label: userContextResource.options.label,
                icon: userContextResource.icon,
                path: userContextResource.link,
                product: userContextResource.products

            }),

            JuristtaMenuItem({
                id: institutionBranchResource.name,
                label: institutionBranchResource.options.label,
                icon: institutionBranchResource.icon,
                path: institutionBranchResource.link,
                product: institutionBranchResource.products,
            }),
        ]
    }),

    JuristtaMenuItem({
        id: 'menuAcademic',
        label: 'Acadêmico',
        icon: School,
        children: [

            JuristtaMenuItem({
                id: academicPeriodResource.name,
                label: academicPeriodResource.options.label,
                icon: academicPeriodResource.icon,
                path: academicPeriodResource.link,
                product: academicPeriodResource.products
            }),

            JuristtaMenuItem({
                id: classResource.name,
                label: classResource.options.label,
                icon: classResource.icon,
                path: classResource.link,
                product: classResource.products
            }),

        ]
    }),

    JuristtaMenuItem({
        id: 'menuSchoolActivities',
        label: 'Atividades',
        icon: Gavel,
        children: [

            JuristtaMenuItem({
                id: schoolModelActivitiesResource.name,
                label: 'Matriz',
                icon: schoolModelActivitiesResource.icon,
                path: schoolModelActivitiesResource.link,
                product: schoolModelActivitiesResource.products

            }),

            JuristtaMenuItem({
                id: schoolActivitiesResource.name,
                label: 'Prática',
                icon: schoolActivitiesResource.icon,
                path: schoolActivitiesResource.link,
                product: schoolActivitiesResource.products

            }),

            JuristtaMenuItem({
                id: guidelineTypeResource.name,
                label: guidelineTypeResource.options.label,
                icon: guidelineTypeResource.icon,
                path: guidelineTypeResource.link,
                product: guidelineTypeResource.products

            }),

        ]
    }),

    JuristtaMenuItem({
        id: 'menuInstitutionParams',
        label: 'Parametrizações',
        icon: MenuBook,
        children: [

            JuristtaMenuItem({
                id: activityTypeResource.name,
                label: activityTypeResource.options.label,
                icon: activityTypeResource.icon,
                path: activityTypeResource.link,
                product: activityTypeResource.products

            }),

            JuristtaMenuItem({
                id: externalServiceRequestResource.name,
                label: externalServiceRequestResource.options.label,
                icon: externalServiceRequestResource.icon,
                path: externalServiceRequestResource.link,
                product: externalServiceRequestResource.products

            }),

            JuristtaMenuItem({
                id: processTypeResource.name,
                label: processTypeResource.options.label,
                icon: processTypeResource.icon,
                path: processTypeResource.link,
                product: processTypeResource.products

            }),
        ]
    }),


    JuristtaMenuItem({
        id: 'form-root',
        label: 'Formulários',
        icon: FormatAlignCenter,
        children: [
            JuristtaMenuItem({
                id: formsResource.name,
                label: formsResource.options.label,
                icon: formsResource.icon,
                path: formsResource.link,
                product: formsResource.products,
                custom: true,
                profiles: ['Administrador', 'Coordenador', 'Secretaria', 'Advogado', 'Coordenador geral']
            }),

            JuristtaMenuItem({
                id: formsAvailabilityResource.name,
                label: formsAvailabilityResource.options.label,
                icon: formsAvailabilityResource.icon,
                path: formsAvailabilityResource.link,
                product: formsAvailabilityResource.products,
                custom: true,
                profiles: ['Administrador', 'Coordenador', 'Secretaria', 'Advogado', 'Coordenador geral']
            }),

            JuristtaMenuItem({
                id: 'form-request-dashboard',
                label: 'Minhas Requisições',
                icon: Wallpaper,
                path: '/form-requests-dashboard',
                product: ['office'],
                custom: true,
                profiles: ['Aluno']
            }),

            JuristtaMenuItem({
                id: formsRequestResource.name,
                label: formsRequestResource.options.label,
                icon: formsRequestResource.icon,
                path: formsRequestResource.link,
                product: formsRequestResource.products,
                custom: true,
                profiles: ['Administrador', 'Advogado', 'Coordenador', 'Secretaria', 'Coordenador geral']
            }),
        ]
    }),

    JuristtaMenuItem({
        id: 'quizAssessementRoot',
        label: 'Simulados',
        icon: FormatAlignCenter,
        children: [
            JuristtaMenuItem({
                id: quizAssessmentQuestionResource.name,
                label: quizAssessmentQuestionResource.options.label,
                icon: quizAssessmentQuestionResource.icon,
                path: quizAssessmentQuestionResource.link,
                product: quizAssessmentQuestionResource.products,
                profiles: ['Administrador', 'Coordenador', 'Professor', 'Coordenador geral']
            }),
            JuristtaMenuItem({
                id: quizAssessmentQuestionBankResource.name,
                label: quizAssessmentQuestionBankResource.options.label,
                icon: quizAssessmentQuestionBankResource.icon,
                path: quizAssessmentQuestionBankResource.link,
                product: quizAssessmentQuestionBankResource.products,
                profiles: ['Administrador', 'Coordenador', 'Professor', 'Coordenador geral']
            }),
            JuristtaMenuItem({
                id: quizAssessmentQuestionAvailability.name,
                label: quizAssessmentQuestionAvailability.options.label,
                icon: quizAssessmentQuestionAvailability.icon,
                path: quizAssessmentQuestionAvailability.link,
                product: quizAssessmentQuestionAvailability.products,
                profiles: ['Administrador', 'Coordenador', 'Professor', 'Coordenador geral']
            }),
        ]
    }),

    JuristtaMenuItem({
        id: 'instantTest',
        label: 'Quiz',
        icon: Assessment,
        path: '/quiz-practice',
        product: ['quiz'],
        custom: true,
        profiles: ['Aluno', 'Superadministrador']
    }),


    JuristtaMenuItem({
        id: 'menuNPJ',
        label: 'NPJ',
        icon: Gavel,
        children: [
            JuristtaMenuItem({
                id: serviceRequestResource.name,
                label: serviceRequestResource.options.label,
                icon: serviceRequestResource.icon,
                path: serviceRequestResource.link,
                product: serviceRequestResource.products
            }),


            JuristtaMenuItem({
                id: schedulingResource.name,
                label: schedulingResource.options.label,
                icon: schedulingResource.icon,
                path: schedulingResource.link,
                product: externalServiceRequestResource.products
            }),

            JuristtaMenuItem({
                id: processResource.name,
                label: processResource.options.label,
                icon: processResource.icon,
                path: processResource.link,
                product: processResource.products

            }),

            JuristtaMenuItem({
                id: partyResource.name,
                label: partyResource.options.label,
                icon: partyResource.icon,
                path: partyResource.link,
                product: partyResource.products

            }),

            JuristtaMenuItem({
                id: clientResource.name,
                label: clientResource.options.label,
                icon: clientResource.icon,
                path: clientResource.link,
                product: clientResource.products

            }),


        ]
    }),

    JuristtaMenuItem({
        id: 'reports',
        label: 'Relatórios',
        icon: Assessment,
        path: '/reports',
        product: ['office'],
        custom: true,
        profiles: ['Administrador', 'Advogado', 'Coordenador', 'Secretaria', 'Professor', 'Coordenador geral']
    }),

    JuristtaMenuItem({
        id: 'menuTools',
        label: 'Material de apoio',
        icon: MenuBook,
        children: [

            JuristtaMenuItem({
                id: 'vadeMecum',
                label: 'Vade Mecum',
                icon: MenuBook,
                path: `/vade-mecum`,
                product: ['school', 'office'],
                custom: true,
                profiles: ['Professor', 'Professor gestor', 'Administrador', 'Advogado', 'Coordenador', 'Secretaria', 'Aluno', 'Coordenador geral', 'Advogado geral']
            }),

        ]
    }),

    JuristtaMenuItem({
        id: 'menuWrittenGuide',
        label: 'Manual do usuário',
        icon: Info,
        path: '/manual-do-usuario',
        product: ['school', 'quiz'],
        custom: true,
        profiles: ['Administrador', 'Advogado', 'Coordenador', 'Secretaria', 'Professor', 'Coordenador geral']
    }),

    /*
        JuristtaMenuItem({
            id: 'chatGpt',
            label: 'Juristta IA',
            icon: MenuBook,
            path: `/chat-gpt`,
            product: ['school', 'office'],
            custom: true,
            profiles: ['Professor', 'Professor gestor', 'Administrador', 'Advogado', 'Coordenador', 'Secretaria', 'Aluno', 'Coordenador geral', 'Advogado geral']
        }),
    */

    JuristtaMenuItem({
        id: 'menuTutorials',
        label: 'Tutoriais',
        icon: MenuBook,
        children: [

            JuristtaMenuItem({
                id: 'schoolStudentTutorial',
                label: 'Aluno',
                icon: MenuBook,
                path: `/school-student-tutorial`,
                product: ['school'],
                custom: true,
                profiles: ['Aluno', 'Professor', 'Professor gestor', 'Administrador', 'Advogado', 'Coordenador', 'Secretaria', 'Coordenador geral', 'Advogado geral']
            }),

            JuristtaMenuItem({
                id: 'schoolManagerTutorial',
                label: 'Gestor',
                icon: MenuBook,
                path: `/school-manager-tutorial`,
                product: ['school'],
                custom: true,
                profiles: ['Professor', 'Professor gestor', 'Administrador', 'Advogado', 'Coordenador', 'Secretaria', 'Coordenador geral', 'Advogado geral']
            }),

            JuristtaMenuItem({
                id: 'officeStudentTutorial',
                label: 'Aluno',
                icon: MenuBook,
                path: `/office-student-tutorial`,
                product: ['office'],
                custom: true,
                profiles: ['Aluno', 'Professor', 'Professor gestor', 'Administrador', 'Advogado', 'Coordenador', 'Secretaria', 'Coordenador geral', 'Advogado geral']
            }),

            JuristtaMenuItem({
                id: 'officeManagerTutorial',
                label: 'Gestor',
                icon: MenuBook,
                path: `/office-manager-tutorial`,
                product: ['office'],
                custom: true,
                profiles: ['Professor', 'Professor gestor', 'Administrador', 'Advogado', 'Coordenador', 'Secretaria', 'Coordenador geral', 'Advogado geral']
            }),

            /* JuristtaMenuItem({
                 id: 'quizManagerTutorial',
                 label: 'Administrador',
                 icon: MenuBook,
                 path: '/quiz-manager-tutorial',
                 product: ['quiz'],
                 custom: true,
                 profiles: ['Professor', 'Professor gestor', 'Administrador', 'Secretaria', 'Coordenador', 'Coordenador geral', 'Advogado geral']
             }),

             JuristtaMenuItem({
                 id: 'quizStudentTutorial',
                 label: 'Aluno',
                 icon: MenuBook,
                 path: '/quiz-student-tutorial',
                 product: ['quiz'],
                 custom: true,
                 profiles: ['Aluno']
             }),*/
        ]
    }),

    JuristtaMenuItem({
        id: 'menuDevelopers',
        label: 'Desenvolvedores',
        icon: Code,
        children: [
            JuristtaMenuItem({
                id: 'apiDocs',
                label: 'Documentação API',
                icon: Code,
                path: `/api-docs`,
                product: ['school', 'office'],
                custom: true,
                profiles: ['Administrador', 'Coordenador geral']
            }),
        ]
    }),

]

const shouldShow = (submenu, context) => {
    let currProduct;
    switch (context?.product?.id) {
        case 1:
            currProduct = 'school';
            break;
        case 2:
            currProduct = 'office';
            break;
        case 4:
            currProduct = 'quiz';
            break;
        default:
            currProduct = 'office';
            break;
    }
    const resource = resourceProvider.getResource(submenu.id)
    let resp = false;

    if (submenu.product.includes(currProduct)) {
        if (submenu.custom) {

            if (submenu.profiles.includes(context?.profile?.name)) {
                if (!submenu.superAdmin) { resp = true; }
            }
        } else {
            if (context?.permissions?.find(item => item?.resourceName === resource?.name)?.read === true) {
                if (!submenu.superAdmin) { resp = true; }
            }
        }
        if (context?.profile.name === ProfileEnum.SUPERADMIN) {
            resp = true;
        }
    }
    return resp;
}

export const menuLayoutProvider = {

    getAvailableMenus: (context) => {
        const newMenus = []
        for (const menu of menus) {
            let newSubmenus = [];
            if (menu.children) {
                for (const submenu of menu.children) {
                    if (shouldShow(submenu, context)) {
                        newSubmenus.push(submenu)
                    }
                }

                if (newSubmenus.length > 0) {
                    newMenus.push({ ...menu, children: newSubmenus })
                }
            } else {
                if (shouldShow(menu, context)) { newMenus.push(menu) }
            }

        }
        return newMenus;
    }
}